import { createContext } from 'react'

import { FormGridContextValue } from './interface'

export const FormGridContext = createContext<FormGridContextValue>({})
